import { render } from "./ViewClientModal.vue?vue&type=template&id=3c277a28"
import script from "./ViewClientModal.vue?vue&type=script&lang=js"
export * from "./ViewClientModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__